import type { PlaceCampaignKind } from '@zrsystem/contracts';

export interface CampaignAudiencePreviewKey {
  kind: PlaceCampaignKind;
  referenceDate: string;
}

export const notificationQueryKeys = {
  all: ['notification'] as const,
  whatsappAccount: (placeId: string) =>
    [...notificationQueryKeys.all, 'whatsapp-account', placeId] as const,
  whatsappPairingQr: (placeId: string) =>
    [...notificationQueryKeys.all, 'whatsapp-pairing-qr', placeId] as const,
  whatsappInboxChats: (placeId: string) =>
    [...notificationQueryKeys.all, 'whatsapp-inbox-chats', placeId] as const,
  whatsappInboxMessages: (placeId: string, chatId: string) =>
    [...notificationQueryKeys.all, 'whatsapp-inbox-messages', placeId, chatId] as const,
  notificationConfig: (placeId: string) =>
    [...notificationQueryKeys.all, 'notification-config', placeId] as const,
  partyAlertCadence: (placeId: string, partyId: string) =>
    [...notificationQueryKeys.all, 'party-alert-cadence', placeId, partyId] as const,
  campaigns: (placeId: string) => [...notificationQueryKeys.all, 'campaigns', placeId] as const,
  audiencePreview: (placeId: string, preview: CampaignAudiencePreviewKey) =>
    [...notificationQueryKeys.all, 'audience-preview', placeId, preview] as const,
};
